<!--操作人员配置-->
<template>
  <div class="module">
    <h5 class="module-title">统一支付平台操作人员配置</h5>
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="多人操作模式" name="2"></el-tab-pane>
      <el-tab-pane label="单人操作模式" name="1"></el-tab-pane>
    </el-tabs>
    <div class="module-tips">{{ operateModeTips }}</div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div>
        <h6 class="module-title small-module-title">
          {{ activeTab === '2' ? '经办员' : '操作员' }}
          <span>{{ operatePerson }}</span>
        </h6>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="姓名："
              :prop="`settleAccountUserTempList[0].realName`"
              :rules="rules.realName"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[0].realName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="支付平台登录名称："
              :prop="`settleAccountUserTempList[0].paycenterLoginAccount`"
              :rules="rules.paycenterLoginAccount"
              label-width="141px"
            >
              <el-input
                v-model="
                  ruleForm.settleAccountUserTempList[0].paycenterLoginAccount
                "
                maxlength="50"
                placeholder="请输入登录名称，仅支持英文字母和数字，最大长度50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="证件信息："
              prop="operatorCertificateNo"
              :rules="rules.certificateNo"
              label-width="96px"
              class="document-information"
            >
              <el-select
                v-model="ruleForm.settleAccountUserTempList[0].certificateType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certificateTypeList"
                  :key="item.itemCode"
                  :label="item.itemDisp"
                  :value="item.itemCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="
                  ruleForm.settleAccountUserTempList[0]
                    .settleAccountUserAttachTempList[
                    getIndexByFileType(
                      'UC',
                      ruleForm.settleAccountUserTempList[0]
                        .settleAccountUserAttachTempList
                    )
                  ].certificateNo
                "
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码："
              :prop="`settleAccountUserTempList[0].mobile`"
              :rules="rules.mobile"
              label-width="141px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[0].mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="邮箱地址："
              :prop="`settleAccountUserTempList[0].email`"
              :rules="rules.email"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[0].email"
                placeholder="请输入邮箱地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="证件复印件："
              prop="operatorCertificate"
              :rules="rules.attachPath"
              label-width="96px"
            >
              <div class="flex">
                <eui-upload
                  ref="euiUpload1"
                  key-name="applicantCertificatePath"
                  :file-list="userFileList[0].UC"
                  :action="uploadPayCenterFile"
                  :private-upload="privateUpload"
                  :headers="headers"
                  :show-file-list="true"
                  accept=".jpg,.png"
                  single
                  text="上传附件"
                  @handleSuccess="
                    () => userUploadSuccess('UC', userFileList[0].UC, 0)
                  "
                >
                </eui-upload>
                <eui-btn
                  type="secondary"
                  @click="previewUploadFile(userFileList[0].UC)"
                  >预览
                </eui-btn>
                <span
                  >请上传身份证证件两面清晰的扫描或复印件，限≤2mb，jpg、png格式。</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--      多人操作模式显示-->
      <div v-show="activeTab === '2'">
        <div class="module-line"></div>
        <h6 class="module-title small-module-title">
          审核员
          <span
            >对本公司提交的付款申请、退款申请、收货确认进行付款复审，并可进行提现申请审核；</span
          >
        </h6>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="姓名："
              :prop="`settleAccountUserTempList[1].realName`"
              :rules="rules.realName"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[1].realName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="支付平台登录名称："
              :prop="`settleAccountUserTempList[1].paycenterLoginAccount`"
              :rules="rules.paycenterLoginAccount"
              label-width="141px"
            >
              <el-input
                v-model="
                  ruleForm.settleAccountUserTempList[1].paycenterLoginAccount
                "
                maxlength="50"
                placeholder="请输入登录名称，仅支持英文字母和数字，最大长度50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="证件信息："
              prop="auditorCertificateNo"
              :rules="rules.certificateNo"
              label-width="96px"
              class="document-information"
            >
              <el-select
                v-model="ruleForm.settleAccountUserTempList[1].certificateType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certificateTypeList"
                  :key="item.itemCode"
                  :label="item.itemDisp"
                  :value="item.itemCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="
                  ruleForm.settleAccountUserTempList[1]
                    .settleAccountUserAttachTempList[
                    getIndexByFileType(
                      'UC',
                      ruleForm.settleAccountUserTempList[1]
                        .settleAccountUserAttachTempList
                    )
                  ].certificateNo
                "
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码："
              :prop="`settleAccountUserTempList[1].mobile`"
              :rules="rules.mobile"
              label-width="141px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[1].mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="邮箱地址："
              :prop="`settleAccountUserTempList[1].email`"
              :rules="rules.email"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.settleAccountUserTempList[1].email"
                placeholder="请输入邮箱地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="证件复印件："
              prop="auditorCertificate"
              :rules="rules.attachPath"
              label-width="96px"
            >
              <div class="flex">
                <eui-upload
                  ref="euiUpload1"
                  key-name="applicantCertificatePath"
                  :file-list="userFileList[1].UC"
                  :action="uploadPayCenterFile"
                  :private-upload="privateUpload"
                  :headers="headers"
                  :show-file-list="true"
                  accept=".jpg,.png"
                  single
                  text="上传附件"
                  @handleSuccess="
                    () => userUploadSuccess('UC', userFileList[1].UC, 1)
                  "
                >
                </eui-upload>
                <eui-btn
                  type="secondary"
                  @click="previewUploadFile(userFileList[1].UC)"
                  >预览
                </eui-btn>
                <span
                  >请上传身份证证件两面清晰的扫描或复印件，限≤2mb，jpg、png格式。</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="module-line"></div>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="个人信息处理告知同意书："
            prop="notificationLetter"
            :rules="rules.attachPath"
            label-width="185px"
          >
            <div>1.下载信息处理告知同意书模板：</div>
            <div style="margin-top: -10px" class="gray-color">
              <span
                style="color: #0064c8; cursor: pointer"
                @click="downloadTemplate()"
                >点击下载《信息处理告知同意书模板》</span
              >
              下载后填写相关信息，并扫描后上传
            </div>
            <div>2.上传扫描件：</div>
            <div class="flex">
              <eui-upload
                ref="euiUploadTwo"
                :file-list="userFileList[1].PPN"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                single
                accept=".jpg,.png,.pdf"
                text="上传文件"
                :picure-width="200"
                tip="请上传清晰的扫描或复印件。限≤2mb，jpg、png、pdf格式"
                @handleSuccess="
                  () => userUploadSuccess('PPN', userFileList[1].PPN)
                "
              >
              </eui-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import utils from '@/modules/projectA/utils/utils';
import {
  paymentAccountOpeningMixins,
  commonMethodsMixins,
  downloadTemplateUrl,
} from '../constant';
import ViewerImage from '../components/viewerImage';

export default {
  name: 'UserConfig',
  components: {
    ViewerImage,
  },
  mixins: [paymentAccountOpeningMixins, commonMethodsMixins],
  data() {
    return {
      ruleForm: {
        opMode: 2,
        settleAccountUserTempList: [
          {
            certificateType: 0,
            email: '',
            mobile: '',
            paycenterLoginAccount: '',
            realName: '',
            role: 'F002',
            settleAccountUserAttachTempList: [
              {
                attachName: '',
                attachPath: '',
                attachType: 'UC',
                certificateNo: '',
                certificateValidityBeginStr: '',
                certificateValidityEndStr: '',
                isLongTernEffective: null,
              },
              {
                attachName: '',
                attachPath: '',
                attachType: 'PPN',
                certificateNo: '',
                certificateValidityBeginStr: '',
                certificateValidityEndStr: '',
                isLongTernEffective: null,
              },
            ],
          },
          {
            certificateType: 0,
            email: '',
            mobile: '',
            paycenterLoginAccount: '',
            realName: '',
            role: 'F003',
            settleAccountUserAttachTempList: [
              {
                attachName: '',
                attachPath: '',
                attachType: 'UC',
                certificateNo: '',
                certificateValidityBeginStr: '',
                certificateValidityEndStr: '',
                isLongTernEffective: null,
              },
              {
                attachName: '',
                attachPath: '',
                attachType: 'PPN',
                certificateNo: '',
                certificateValidityBeginStr: '',
                certificateValidityEndStr: '',
                isLongTernEffective: null,
              },
            ],
          },
        ],
      },
      userFileList: [
        {
          UC: [],
          PPN: [],
        },
        {
          UC: [],
          PPN: [],
        },
      ],
      activeTab: '2',
      operateModeTips:
        '说明：注册多个用户分别管理和执行支付平台相关功能，功能包括系统管理、初审和复审等。',
      operatePerson:
        '对本企业提交的付款申请、退款申请、收货确认进行付款初审，并可进行提现申请操作。',
      copySettleAccountUserTempList: [
        {
          certificateType: 0,
          email: '',
          mobile: '',
          paycenterLoginAccount: '',
          realName: '',
          role: 'F002',
          settleAccountUserAttachTempList: [
            {
              attachName: '',
              attachPath: '',
              attachType: 'UC',
              certificateNo: '',
              certificateValidityBeginStr: '',
              certificateValidityEndStr: '',
              isLongTernEffective: null,
            },
            {
              attachName: '',
              attachPath: '',
              attachType: 'PPN',
              certificateNo: '',
              certificateValidityBeginStr: '',
              certificateValidityEndStr: '',
              isLongTernEffective: null,
            },
          ],
        },
        {
          certificateType: 0,
          email: '',
          mobile: '',
          paycenterLoginAccount: '',
          realName: '',
          role: 'F003',
          settleAccountUserAttachTempList: [
            {
              attachName: '',
              attachPath: '',
              attachType: 'UC',
              certificateNo: '',
              certificateValidityBeginStr: '',
              certificateValidityEndStr: '',
              isLongTernEffective: null,
            },
            {
              attachName: '',
              attachPath: '',
              attachType: 'PPN',
              certificateNo: '',
              certificateValidityBeginStr: '',
              certificateValidityEndStr: '',
              isLongTernEffective: null,
            },
          ],
        },
      ],
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(sourceData) {
      this.activeTab = sourceData?.opMode?.toString() ?? '2';
      this.ruleForm.opMode = sourceData?.opMode;
      if (!sourceData?.settleAccountUserTempList?.length) {
        return;
      }
      this.ruleForm.settleAccountUserTempList.forEach((userItem, index) => {
        Object.keys(userItem).forEach((key) => {
          if (key === 'role') {
            return;
          }
          if (key === 'settleAccountUserTempList') {
            // userItem[key].forEach(attachItem => {
            //   attachItem[attachKey] = sourceData.settleAccountUserTempList[index]?.settleAccountUserAttachTempList
            // })
            userItem[key] = sourceData.settleAccountUserTempList[index]
              ?.settleAccountUserAttachTempList
              ? [
                  ...sourceData.settleAccountUserTempList[index]
                    .settleAccountUserAttachTempList,
                ]
              : userItem.settleAccountUserAttachTempList;
          } else {
            userItem[key] =
              sourceData.settleAccountUserTempList[index]?.[key] ??
              userItem[key];
          }
        });
        userItem.settleAccountUserAttachTempList.forEach((attachItem) => {
          // 操作人附件回显
          if (attachItem.attachName && attachItem.attachPath) {
            this.userFileList[index][attachItem.attachType].push({
              name: attachItem.attachName,
              url: attachItem.attachPath,
            });
          }
        });
      });
      this.handleTabClick(false);
      if (this.activeTab === '1') {
        this.userFileList[1].PPN = this.userFileList[0].PPN;
        this.ruleForm.settleAccountUserTempList[1].settleAccountUserAttachTempList[1] =
          this.ruleForm.settleAccountUserTempList[0].settleAccountUserAttachTempList[1];
      }
      console.log(this.ruleForm, 'userConfig init');
    },
    // 统一支付平台操作人员配置-切换操作模式
    handleTabClick(isReset = true) {
      this.ruleForm.opMode = this.activeTab;
      if (isReset) {
        this.ruleForm.settleAccountUserTempList = utils.cloneDeep(
          this.copySettleAccountUserTempList
        );
        this.userFileList.forEach((item) => {
          item.UC = [];
          item.PPN = [];
        });
      }
      if (this.activeTab === '2') {
        this.operateModeTips =
          '说明：注册多个用户分别管理和执行支付平台相关功能，功能包括系统管理、初审和复审等。';
        this.operatePerson =
          '对本企业提交的付款申请、退款申请、收货确认进行付款初审，并可进行提现申请操作。';
      } else {
        this.operateModeTips =
          '说明：仅注册一个用户来管理和执行支付平台全部功能。';
        this.operatePerson =
          '对本公司提交的付款申请、退款申请、收货确认进行付款初审/复审，并可进行提现申请操作。';
      }
    },
    // 下载模板
    async downloadTemplate() {
      let path = '';
      if (this.activeTab === '2') {
        // 个人信息处理告知同意书-多人操作模式
        path = `${downloadTemplateUrl}/%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%A4%84%E7%90%86%E5%91%8A%E7%9F%A5%E5%90%8C%E6%84%8F%E4%B9%A6%E6%98%93%E6%94%AF%E4%BB%98-%E5%A4%9A%E4%BA%BA%E6%A8%A1%E5%BC%8F.docx`;
      } else {
        // 个人信息处理告知同意书-单人操作模式
        path = `${downloadTemplateUrl}/%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%A4%84%E7%90%86%E5%91%8A%E7%9F%A5%E5%90%8C%E6%84%8F%E4%B9%A6%E6%98%93%E6%94%AF%E4%BB%98-%E5%8D%95%E4%BA%BA%E6%A8%A1%E5%BC%8F.docx`;
      }
      window.open(path);
    },
    // 操作人附件上传
    userUploadSuccess(certificateType, attachObj, index) {
      this.reUploadFlag = true;
      // console.log(this.userFileList, 'userFileList');
      if (certificateType === 'UC') {
        const tempObj = this.ruleForm.settleAccountUserTempList[
          index
        ].settleAccountUserAttachTempList.find(
          (attach) => attach.attachType === certificateType
        );
        if (tempObj) {
          this.$set(
            tempObj,
            'attachName',
            attachObj[0]?.response?.data.fileName
          );
          this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
        }
      } else {
        this.ruleForm.settleAccountUserTempList.forEach((item) => {
          const tempObj = item.settleAccountUserAttachTempList.find(
            (attach) => attach.attachType === certificateType
          );
          if (tempObj) {
            this.$set(
              tempObj,
              'attachName',
              attachObj[0]?.response?.data.fileName
            );
            this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
          }
        });
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
